import React,
{ useState } from 'react'
import {
  useMutation,
  useQueryClient
} from 'react-query'
import { Link } from 'react-router-dom'

import { IconButton } from '@driftt/tide-core'
import { ignoreCandidate } from 'api/contacts'
import Flyout from 'components/lib/Flyout'

import './style.css'


const DuplicatesListActionMenu = ({ candidate }) => {
  const [open, toggleOpen] = useState(false)
  const queryClient = useQueryClient()

  const ignoreMutation = useMutation(email => ignoreCandidate({ email }), {
    onSuccess: () => {
      queryClient.invalidateQueries('merge-candidates')
      toggleOpen(false)
    }
  })

  return (
    <Flyout
      open={open}
      toggle={toggleOpen}
      trigger={() => (
        <div onClick={() => toggleOpen(open ? false : true)}>
          <IconButton icon="meatballs" />
        </div>
      )}
      target={() => (
        <div className="crm-duplicates-list-action-menu">
          <ul>
            <li> <Link to={`/duplicates/merge/${candidate.email}`}>Merge duplicates</Link></li>
            <li onClick={() => ignoreMutation.mutate(candidate.email)}>Remove duplicates from list</li>
          </ul>
        </div>
      )}
    />
  )
}

export default DuplicatesListActionMenu
